import React from 'react';

const CategoriaEstrella = (props) => {
  const crearEstrella = (index) => {
    const { color, name } = props;
    const style = {
      padding: '0px',
      margin: '0px',
    };
    if (color) {
      return (<i key={index} title={name} id='categoriaHotel' className='fa fa-star yellow' style={style} aria-hidden='true' />);
    }
    return (<i key={index} title={name} id='categoriaHotel' className='fa fa-star icon-gray' style={style} aria-hidden='true' />);
  };

  const { clase } = props;
  const style = {
    padding: '0px',
    margin: '0px',
  };
  const estrellas = [];
  let estrella = null;
  for (let i = 1; i <= 5; i++) {
    if (i <= clase) {
      estrella = crearEstrella(i);
      estrellas.push(estrella);
    }
  }

  return (
    <div style={style} id='categoriaHotel' name={props.name}>
      {estrellas.map((e) => e)}
    </div>
  );
};

export default CategoriaEstrella;
